module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-text-header"
  }, [_c('div', {
    staticClass: "block-text-header__container"
  }, [_c('div', {
    staticClass: "block-text-header__title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.props.title))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bc5a10c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-text-main-header/block-text-main-header.pug
// module id = 609
// module chunks = 1